// extracted by mini-css-extract-plugin
export default {"root":"_1dmtgqiFMiztaX755TR82y","active":"szc3Z27ZxAiqfam7qjnc3","listIcon":"_3cvTli9PtQIrGNXHmcVkbT","bottomNavigation":"_1vKTpjv1bIf8flggDIPbQ-"};